import { useEffect } from 'react';

export const ReloadPage = () => {
  useEffect(() => {
    console.log('Page reload required...');

    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  }, []);

  return null;
};
